import { render, staticRenderFns } from "./ConferenceAgents.vue?vue&type=template&id=a0fa8578&"
import script from "./ConferenceAgents.vue?vue&type=script&lang=ts&"
export * from "./ConferenceAgents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports